//Call_[npm_run_updateIndexes]_to_update_this_file.

// @create-index

import _useCaseDetail from './useCaseDetail';
export const useCaseDetail = _useCaseDetail;
export default {useCaseDetail};

